module.exports = __webpack_public_path__ + "img/0xbA2aE424d960c26247Dd6c32edC70B295c744C43.f06b603b.png";